import Entity from 'utilities/Entity';

class Group extends Entity {}

export default new Group();
